import '@/index.css';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { Toaster } from '@/components/ui/sonner';
import { useEffect } from 'react';
import axios from 'axios';
import Login from '@/pages/Login';
import Dashboard from '@/pages/Dashboard';
import ConventionManager from '@/pages/ConventionManager';
import EventDetail from '@/pages/EventDetail';
import Analytics from '@/pages/Analytics';
import Documents from '@/pages/Documents';
import ConventionDatabase from '@/pages/ConventionDatabase';
import ApplyVolunteer from '@/pages/ApplyVolunteer';
import ApplyPaid from '@/pages/ApplyPaid';
import UserManagement from '@/pages/UserManagement';
import Reports from '@/pages/Reports';
import Optimizer from '@/pages/Optimizer';
import EmployeeRegister from '@/pages/EmployeeRegister';
import TrainingGuide from '@/pages/TrainingGuide';
import InvoiceView from '@/pages/InvoiceView';
import ConventionSales from '@/pages/ConventionSales';
import ProductSales from '@/pages/ProductSales';
import Inventory from '@/pages/Inventory';
import ShowTypeProfitability from '@/pages/ShowTypeProfitability';
import StaffHub from '@/pages/StaffHub';
import CalendarTasks from '@/pages/CalendarTasks';
import ExecutionBoard from '@/pages/ExecutionBoard';
import MeetingNotes from '@/pages/MeetingNotes';
import Layout from '@/components/Layout';

// Setup axios interceptor for auth errors
axios.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      // Token expired or invalid - redirect to login
      localStorage.removeItem('vyrus_token');
      localStorage.removeItem('vyrus_user');
      window.location.href = '/login';
    }
    return Promise.reject(error);
  }
);

const ProtectedRoute = ({ children }) => {
  const token = localStorage.getItem('vyrus_token');
  if (!token) {
    return <Navigate to="/login" replace />;
  }
  return children;
};

function App() {
  return (
    <>
      <BrowserRouter>
        <Routes>
          <Route path="/login" element={<Login />} />
          <Route path="/register" element={<EmployeeRegister />} />
          {/* Public Invoice Page - customers can view their invoice */}
          <Route path="/invoice/:id" element={<InvoiceView />} />
          {/* Public Staff Application Routes */}
          <Route path="/apply/volunteer/:eventId" element={<ApplyVolunteer />} />
          <Route path="/apply/paid/:eventId" element={<ApplyPaid />} />
          <Route
            path="/"
            element={
              <ProtectedRoute>
                <Layout />
              </ProtectedRoute>
            }
          >
            <Route index element={<Dashboard />} />
            <Route path="events" element={<ConventionManager />} />
            <Route path="events/:id" element={<EventDetail />} />
            <Route path="calendar" element={<CalendarTasks />} />
            <Route path="execution-board" element={<ExecutionBoard />} />
            <Route path="meeting-notes" element={<MeetingNotes />} />
            <Route path="analytics" element={<Analytics />} />
            <Route path="product-sales" element={<ProductSales />} />
            <Route path="documents" element={<Documents />} />
            <Route path="convention-database" element={<ConventionDatabase />} />
            <Route path="staff-hub" element={<StaffHub />} />
            <Route path="users" element={<UserManagement />} />
            <Route path="reports" element={<Reports />} />
            <Route path="optimizer" element={<Optimizer />} />
            <Route path="training-guide" element={<TrainingGuide />} />
            <Route path="convention-sales" element={<ConventionSales />} />
            <Route path="inventory" element={<Inventory />} />
            <Route path="show-profitability" element={<ShowTypeProfitability />} />
          </Route>
        </Routes>
      </BrowserRouter>
      <Toaster position="top-right" />
    </>
  );
}

export default App;
